import React from 'react';
import './index.css';

import bigicoadministra from 'assets/images/bigico-administra.png';

function Article({ variant }) {
  return (
    <div className='finanzasgrid'>
      <div className='finanzasgrid__text'>
        <div className='col-narrow'>
          <h4>Finanzas en orden</h4>
          <p className='strong'>Conocé tu situación financiera y detectá cómo cuidar tus ingresos para hacerlos crecer.</p>
          <p>El presupuesto es una herramienta de registro que nos permite ver en detalle nuestros ingresos y nuestros gastos y tomar mejores decisiones. Sirve tanto para nuestras finanzas personales y/o familiares como las de nuestro emprendimiento.</p>
          <p><strong>Para armar un presupuesto es importante tener en cuenta:</strong></p>
          <ul className='small-list'>
            <li>Registrar todos los ingresos y gastos.</li>
            <li>Definir un monto para el ahorro.</li>
            <li>Establecer prioridades.</li>
            <li>Eliminar gastos innecesarios.</li>
          </ul>
        </div>
      </div>
      <div className='finanzasgrid__link bigbtn-container'>
        <img src={bigicoadministra} alt="Icono de descarga" className='big-icon' />
        <div className="bigbtn-container__group">
          <p>Descargá el Organizador de Finanzas Personales!</p>
          <a href="descargas/organizador-finanzas-personales.xlsx" target='_blank' rel='noreferrer' className='btn-verde'>Descargar</a>
        </div>
      </div>
      <div className="finanzasgrid__video">
        <div className="videos">
          <div className="embed-container small">
            <h5>¿Cómo ahorrar y aprender a invertir?</h5>
            <div className='embed-responsive embed-responsive-16by9 with-curves'>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/Y6VmWZpJWQU?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Article;
